import { HttpMethods } from "./HttpMethods";
import { Logger } from "./Logger";

export async function makeJsonRequest(
  url: string,
  method: HttpMethods,
  credentials: RequestCredentials,
  requestBody?: object,
): Promise<Response> {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  const requestInit: RequestInit = {
    method: method,
    headers: headers,
    body: JSON.stringify(requestBody),
    credentials: credentials,
  };
  let response: Response | undefined = undefined;
  let requestNumber = 1;
  while (!response) {
    try {
      response = await fetch(url, requestInit);
      if (requestNumber > 1) {
        Logger.debugLog(
          `Request to (${method})${url} succeeded on request #${requestNumber}. Status code: ${response.status}`,
        );
      }
    } catch (e) {
      if (url.endsWith("/marea/logs")) {
        // Don't retry to send Marea's logs, it creates an infinite loop.
        throw e;
      }
      if (requestNumber >= 3) {
        Logger.error(`Request failed (request #${requestNumber})`, {
          "fetch.request": formatRequestInit(url, requestInit),
          exception: e,
        });
        throw e;
      } else {
        Logger.warn(`Request to (${method}) ${url} failed, retrying. Request #${requestNumber}`);
      }
      requestNumber++;
    }
  }
  return response;
}

function formatRequestInit(url: string, requestInit: RequestInit): string {
  const lines = [] as string[];
  lines.push(`URI: ${url}`);
  lines.push(`Method: ${requestInit.method}`);
  lines.push(`Body: ${requestInit.body}`);
  lines.push(`Credentials: ${requestInit.credentials}`);
  lines.push(`Headers: ${JSON.stringify(requestInit.headers)}`);
  return lines.join("\n");
}
